@if (total.count && cartService.showWidget) {
  <div class="cart" [ngClass]="{ 'cart--reduced': cartService.smallWidget }">
    <div class="cart__container container">
      <div class="cart__preview">
        <a
          class="cart__icon-wrap"
          [routerLink]="['/cart'] | localize"
          [title]="'TO_CART' | translate"
        >
          <div class="position-relative">
            <img class="cart__icon" src="/assets/img/icons/cart.svg" alt="" />
            <span class="cart__counter litera">{{ total.count }}</span>
          </div>
        </a>
        <h2 class="cart__title mb-0 ml-3 ml-sm-4">{{ 'CART' | translate }}</h2>
      </div>
      <div class="cart__actions pr-3">
        <p class="mb-0">
          <span class="price"
            >{{ total.total | number: '1.2-2'
            }}<span class="price__currency">
              {{ 'BYN' | translate }}
              @if (total.total_include_nds) {
                <span class="lowercase"
                  >({{ 'INCLUDE_NDS_SHORT' | translate }}:
                  {{ total.total_include_nds | number: '1.2-2' }}
                  {{ 'BYN' | translate }})</span
                >
              }
            </span>
          </span>
        </p>
        <a
          [routerLink]="['/cart'] | localize"
          class="button button--filled button--shadow ml-3 ml-sm-4 mr-5"
        >
          {{ 'FOLOW' | translate }}
        </a>
      </div>
    </div>
  </div>
}
